import type { ReportingPeriod } from '../types';

export enum PerformanceReportFilterTransactionStatus {
  pending = 'pending',
  closed = 'closed',
}

export enum PerformanceReportFilterTransactionType {
  listing = 'LISTING',
  offer = 'OFFER',
}

interface FilterOption {
  label: string;
  value: string;
}

export interface PerformanceReportFiltersFormValues {
  reportingPeriod: ReportingPeriod;
  customDateStart?: string;
  customDateEnd?: string;
  agents: FilterOption[];
  teams: FilterOption[];
  status: PerformanceReportFilterTransactionStatus[];
  hideTerminatedAgents: boolean;
  transactionType: PerformanceReportFilterTransactionType[];
  leadSources: FilterOption[];
}
